import React from 'react';
import ImageBanner from '../ImageBanners/ImageBanner';

const ModuleImageBanner = ({ imageBannerVersion, advImages }) => {
  return (
    <ImageBanner
      imageBannerVersion={imageBannerVersion}
      advImages={advImages}
    />
  );
};
export default ModuleImageBanner;
